import { render } from "./AdicionarActivos.vue?vue&type=template&id=26f720fc&scoped=true"
import script from "./AdicionarActivos.vue?vue&type=script&lang=js"
export * from "./AdicionarActivos.vue?vue&type=script&lang=js"

import "./AdicionarActivos.vue?vue&type=style&index=0&id=26f720fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f720fc"]])

export default __exports__